const actionTypes = {
  NEW_SESSION_MESSAGE: "seneca/sessionMessage/NEW_SESSION_MESSAGE",
  COMPLETE_SESSION_MESSAGE: "seneca/sessionMessage/COMPLETE_SESSION_MESSAGE"
};

export default actionTypes;
